module.exports = __webpack_public_path__ + "static/ama-23fb3a84292803b4fde52b597fab458e.png";